<template>
  <div class="div">
    
      
        <div class="row xs12 md12 lg12 nav  ">
            <div class="flex xs12 md1 back">
                <a href="https://www.medicinaucp.com/" target="_blank"><img class="logo" src="./imgs/logo-black.png" title="UCP Universidade central do Paraguai"></a>
            </div>
          
            <div class="row row-separated pad mobile">
                <div class="flex xs12 lg2 xs12 "><i class="va-icon fa fa-whatsapp" style="font-size: 20px; padding: 3px;"> +595 994 284911</i></div>
                <div class="flex xs12 lg2 xs12"><i class="va-icon fa fa-whatsapp" style="font-size: 20px; padding: 3px;"> +595 994 159410</i></div>
                <div class="flex xs12 lg2 xs12"><i class="va-icon ion ion-ios-mail" style="font-size: 20px; padding: 3px;"> sga@central.edu.py</i></div>
                <div class="app-navbar__actions row flex-nowrap align--center">
                Idioma:  <language-dropdown class="va-navbar__item"/>
                </div>
            </div>
       </div>


      <div class="row flex xs12 md12 esp ">
          
          <div class=" flex xs12 md8 ">
            <div class="row">
              <div v-if="this.$t('arealuno.Idioma') == 'es'" class="flex xs12 md6 ">

                 <!-- <va-card class="titulo">  -->
                  <p class="text-center display-3">FACULTAD DE POSGRADO</p>
                    <hr>
                  <div v-for="(curso,index) in getGradeCurricular" :key="index"  class="display-5 my-2 text-center">
                    

                    <va-button  type="submit" @click="mudar_curso(curso)"  color="info"  class="my-0 tamanho">{{curso.nome_curso}}</va-button>
                  </div>
                <!-- </va-card> -->

              </div>

               <div v-if="this.$t('arealuno.Idioma') == 'pt'" class="flex xs12 md6 ">

                 <!-- <va-card class="titulo">  -->
                  <p class="text-center display-3">FACULTAD DE POSGRADO</p>
                    <hr>
                  <div v-for="(curso,index) in getGradeCurricular" :key="index"  class="display-5 my-2 text-center">
                    

                    <va-button  type="submit" @click="mudar_curso(curso)"  color="info"  class="my-0 tamanho">{{curso.nome_pt}}</va-button>
                  </div>
                <!-- </va-card> -->

              </div>

            </div>
            <br>
            <div class="row">

                <div class="flex xs12 md7"> 
                   <p class="text-center display-3">Video</p>
                  <hr>

                 <iframe class="text-center" width="100%" height="315" src='http://api.ucpvirtual.com.br/storage/videos/apresentacao.webm'
                  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  >
                  </iframe>
                    
                </div>

            </div>       
            
          </div>
          
          <div class=" flex xs12 md4">
                    <div class="mobile">
                      <img class="imag" src="./imgs/UCP-logo.png" alt="Universidad central del ParaguaY">

                    </div>
    
                  
                  <div class="auth-layout__card">
                  
                        <va-tabs
                          v-model="tabIndex"
                          center
                        >
                          <va-tab class="cor_texto">{{ $t('gestaopessoas.Alunos') }}</va-tab>
                          <va-tab class="cor_texto">{{ $t('gestaopessoas.Professores') }}</va-tab>
                        </va-tabs>

                        <va-separator/>

                        <div class="">
                          <router-view/>
                        </div>
                 
                  </div>


                   <div class="row">

                <div class="flex xs12 md12"> 
<!-- 
                  <p class="text-center display-3">{{ $t('arealuno.ESTRUCTURA') }}</p>
                  <hr> -->

                    <div>

                      <vue-flux
                          :options="fluxOptions"
                          :images="fluxImages"
                          :transitions="fluxTransitions"
                          ref="slider">
                              <flux-pagination slot="pagination"></flux-pagination>
                        </vue-flux>

                    </div>
                    
                </div>

            </div>  

          </div>
          
    
      </div>
      <br>
      <div class="row rodape ">
        
         
            <div class="  flex xs12 md3">

              <va-button @click="abrir_arquivo('cones.pdf')" class="grid__container flex-center pad " color="secondary" style=" width: 100%;"  > HABILITACIÓN INSTITUCIONAL</va-button>

            </div>
            <div class=" flex xs12 md2">

              <va-button @click="abrir_arquivo('conesfilial.pdf')" class="grid__container flex-center pad " color="secondary" style=" width: 100%;"  > CONES</va-button>

            </div>
            <div class=" flex xs12 md2">

               <va-button @click="abrir_arquivo('convenio.pdf')" class="grid__container flex-center pad "  color="secondary" style=" width: 100%;" > CONVENIOS</va-button>

            </div>
            <div class=" flex xs12 md3">

               <va-button @click="abrir_arquivo('lei.pdf')" class="grid__container flex-center pad " color="secondary" style=" width: 100%;" > MINISTERIO DE EDUCACION Y CIENCIAS </va-button>

            </div>
            <div class=" flex xs12 md2">

               <va-button @click="abrir_biblioteca()" class="grid__container flex-center pad " color="secondary" style=" width: 100%;" > BIBLIOTECA VIRTUAL </va-button>

            </div>
        
        
      </div>
   
 
  </div>
</template>

<script>

import { VueFlux, FluxPagination, Transitions } from 'vue-flux';
import LanguageDropdown from './dropdown/LanguageDropdown';


const tabs = [
  'login',
  'administrativo',

]

export default {
  name: 'AuthLayout',
  components: {
    VueFlux,
    FluxPagination,
    LanguageDropdown

  },
  data () {

    return {

      fluxOptions: {
         allowFullscreen: false,
          allowToSkipTransition: true,
          autohideTime: 2500,
          autoplay: true,
          bindKeys: false,
          delay: 5000,
          enableGestures: false,
          infinite: true,
          lazyLoad: true,
          lazyLoadAfter: 3,
      },
      
      fluxImages: [
        
         'http://api.ucpvirtual.com.br/storage/carrossel/DSC9243.jpg',
         'http://api.ucpvirtual.com.br/storage/carrossel/GOR_7631.jpg',
         'http://api.ucpvirtual.com.br/storage/carrossel/GOR_1536.jpg',
         'http://api.ucpvirtual.com.br/storage/carrossel/GOR_7646.jpg'
      ],
      fluxTransitions: {
         transitionBook: Transitions.transitionCube,
         transitionBlocks2: Transitions.transitionBlocks2,
         transitionCamera: Transitions.transitionCamera,
         transitionBlinds2d: Transitions.transitionBlinds2d,
      },

      selectedTabIndex: 0,
      tabTitles: ['login', 'professores'],

      user: '',
      password: '',
    }
  },
  created(){
this.allCursos()

  },
  computed: {
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
      
    },
    getGradeCurricular (){
        return  this.$store.state.gradecurricular.gradecurricular   
        
    },

  },
  methods:{
    abrir_arquivo(arquivo){
      
      let url = "http://api.ucpvirtual.com.br/storage/documentos/"+ arquivo 
      window.open(url, "_blank");

    },
    abrir_biblioteca(){
      
      let url = "https://www.dropbox.com/sh/jzuqb5gpnqcue47/AACUtJUnjnLF2zW5GUPpWJn9a?dl=0" 
      window.open(url, "_blank");

    },
    mudar_slide(){

      setInterval(this.trocar_classe,2000)

    },
    trocar_classe(){

     

    },
    allCursos() {
      let grade = this.$store.dispatch('allGradeCurricular')
     
    },
    mudar_curso(curso){
     console.log(curso)
      this.$store.dispatch('getInfoGrade',curso)
      this.$router.push({ name: 'inscricao/informacoes' })
    }
    
  }
}
</script>

<style lang="scss"  >

 .cor_texto {
  background-color: #fff;
  color: #000000;
  text-align: justify;
}

.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, #4d77c9, #72819e);

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}
.back :hover {
  background-color: cornflowerblue;
}

#titulo {
  font-family: 'Studeo Bold' !important;
  text-align: justify;
  opacity: .8;
  color: #3c079e;
  font-size: 40px;
}
 #cor {
  background-color: #fff;
  color: #626262;
  opacity: .8;
  text-align: justify;
}
.tamanho {
  width: 100%;
  text-align: justify;
}
.esp {
  margin-top: 70px;
  margin-left: 15px;
  margin-right: 15px;
  opacity: 1;
}
.div{
  max-width: 99%;

}
.nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: white;
  opacity: .8;
  text-align: center;
}
.rodape {
  
  //position: absolute;
	bottom: 0;
  width: 100%;
  background-color: white;
  text-align: center;
}
.imag {
  width: 100%;
}
.logo {
  padding-top: 3px;
  width: 50px;
}
.pad {
  margin: 10px;
}
 body {
   background-image: url('./imgs/fachada2.2.2.jpg');
   background-size: cover;
   background-attachment: fixed;
   background-repeat: no-repeat;
   background-position: center center;
  
 }
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .mobile {display: none;}
}


	
</style>
